import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import get from 'lodash/get';
import Tabs from '@components/common/Dashboard/DashboardTabs/Tabs';
import AiAlertsComponent from '@components/aiAlerts';
import { setInitialData } from '@store/aiAlerts/base/actions';
import { reset } from '@store/aiAlerts/actions';
import { intervalSelector, isInitializingSelector } from '@store/aiAlerts/base/selectors';
import { Retry } from '@components/common';
import { getDateShortcutsWithInterval } from '@components/common/date-picker-v2/dateUtils';
import { AI_ALERT_DATE_SHORTCUTS } from '@utils/aiAlerts/mapping';
import usePageTitle from '@src/hooks/usePageTitle';
import { Wrapper, TabRow } from './styled';

const AiAlerts = (props) => {
  const { match, pageType } = props;
  const currentShareId = get(match, 'params.id', 'ai-alerts');
  const dispatch = useDispatch();
  const isInitializing = useSelector(isInitializingSelector);
  const interval = useSelector(intervalSelector);

  usePageTitle({ text: 'AI Alerts' });

  const getSelectedInterval = () => {
    const shortcuts = getDateShortcutsWithInterval(AI_ALERT_DATE_SHORTCUTS);
    const [shortcut, interval] = shortcuts[1];
    // set initial selected interval
    const selectedInterval = {
      from: moment(interval[0]).format(),
      to: moment(interval[1]).format(),
      shortcut,
    };

    return selectedInterval;
  };

  useEffect(() => {
    if (!interval || isInitializing) {
      dispatch(
        setInitialData({
          interval: getSelectedInterval(),
        }),
      );
    }
    // reset state on unmount
    return () => {
      dispatch(reset());
    };
  }, []);

  if (isInitializing) {
    return <Retry isLoading={isInitializing} />;
  }

  return (
    <Wrapper>
      <TabRow>
        <Tabs currentShareId={currentShareId} pageType={pageType} />
      </TabRow>
      <AiAlertsComponent />
    </Wrapper>
  );
};

export default AiAlerts;
